export default __webpack_public_path__ + "static/navImg3-3a4b92e99e329c1e4e92b1207e700110.jpg";